import { configureStore } from "@reduxjs/toolkit";
import user from "./user";
import notification from "./notification"

const store = configureStore({
    reducer: {
        user, notification
    }
})

export default store;